import {gql} from 'apollo-angular';
import {ImageFragment} from "./Image";

export const MediaGalleryFragment = gql`
  fragment mediaGalleryFields on Gallery {
    galleryItems {
      visible
      position
      id
      contentType
      video {
        title
        author
        authorUrl
        thumbnailUrl
        thumbnailHeight
        thumbnailWidth
        src
      }
      image {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
